var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-input",on:{"click":function($event){return _vm.$refs.input.click()}}},[_c('span',{staticClass:"file-input__label"},[_vm._v(_vm._s(this.name || _vm.$t("CHOOSE_FILE")))]),_c('input',{ref:"input",staticClass:"file-input__control",attrs:{"type":"file"},on:{"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }